<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<template>
  <div v-if="isSearching" class="flex flex-col w-full items-center">
    <svg aria-hidden="true" class="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-100 fill-blue-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
      <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
    </svg>
    <span>{{ $t('loading') }}</span>
  </div>
  <div v-else>
    <div class="flex flex-col items-center w-full space-y-2" v-if="pantheraCustomers.length === 0">
      <p class="text-lg">{{ $t('customers.customer_not_found') }}</p>
      <div v-if="isLoading" class="flex flex-col w-full items-center">
        <svg aria-hidden="true" class="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-100 fill-blue-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
        </svg>
        <span>{{ $t('loading') }}</span>
      </div>
      <base-button v-else
        @click.prevent="createPantheraCustomer()"
        :disabled="disableCreate"
        extra-class="border-blue-400 text-blue-400 hover:bg-blue-300 dark:disabled:hover:text-gray-300
        disabled:border-gray-300 disabled:text-gray-300 disabled:bg-gray-100 dark:disabled:bg-slate-500"
      >
        {{ $t('customers.add_panthera_customer') }}
      </base-button>
    </div>

    <div v-else>
      <div class="grid grid-cols-2 xl:grid-cols-3 gap-x-8 gap-y-4 pb-4">
        <p class="col-span-2 xl:col-span-3 text-xl capitalize">{{ $t('customers.select_panthera_customer') }}</p>
        <div
          v-for="pantheraCustomer in customersSubset" :key="pantheraCustomer.idCliente"
          class="flex"
        >
          <input type="radio" v-model="selectedCustomer" :value="pantheraCustomer"
            class="flex items-center mr-2 appearance-none border border-gray-400 dark:border-gray-100
            rounded-[0.15rem] w-4 h-4 checked:outline-none checked:after:content-['\2713']"
          />
          <p class="text-left flex border border-gray-400 dark:border-gray-100 rounded py-1 px-2 w-full">
            {{ pantheraCustomer.ragioneSociale }}<br>{{ pantheraCustomer.codiceFiscale }}<br>{{ pantheraCustomer.idCliente }}<br>{{ pantheraCustomer.email }}
          </p>
        </div>
        <base-button
          @click.prevent="selectedPantheraCustomer()"
          :disabled="confirmIsDisabled"
          extra-class="h-fit col-span-2 xl:col-span-3 place-self-end border-blue-400 text-blue-400 hover:bg-blue-300
          disabled:border-gray-300 disabled:text-gray-300 disabled:bg-gray-100 dark:disabled:bg-slate-500 dark:disabled:hover:text-gray-300"
        >
          {{ $t('customers.confirm') }}
        </base-button>
      </div>
      <div class="flex flex-col items-center w-full space-y-2 border-t border-gray-100 pt-4">
        <p class="text-xl mb-1">{{ $t('customers.customer_not_in_list') }}</p>
        <base-button @click.prevent="createPantheraCustomer()"
        extra-class="border-blue-400 text-blue-400 hover:bg-blue-300">
          {{ $t('customers.add_panthera_customer') }}
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { useToast } from 'vue-toastification';
import BaseButton from '../base/BaseButton.vue';

export default {
  components: {
    BaseButton,
  },
  emits: ['close', 'panthera_customer_has_been_selected', 'panthera_customer_has_been_created'],
  data() {
    return {
      selectedCustomer: {},
      pantheraCustomers: [],
      newPantheraCustomerId: '',
      disableCreate: false,
      isLoading: false,
      isSearching: false,
    };
  },
  props: {
    customer: {
      type: Object,
    },
    billingAddress: {
      type: Object,
    },
  },
  async created() {
    await this.searchPantheraCustomer();
  },
  setup() {
    const toast = useToast();

    return { toast };
  },
  computed: {
    customersSubset() {
      return this.pantheraCustomers.slice(0, 6);
    },
    confirmIsDisabled() {
      return Object.entries(this.selectedCustomer).length === 0;
    },
  },
  methods: {
    setSdiCode() {
      if (this.customer.type === 'G') return this.customer.sdi_code;
      return this.billingAddress.country === 'IT' ? '0000000' : 'XXXXXXX';
    },
    selectedPantheraCustomer() {
      this.$emit('panthera_customer_has_been_selected', this.selectedCustomer);
      this.toast.success(this.$t('customers.toast_customer_selected'));
    },
    async searchPantheraCustomer() {
      this.isSearching = true;
      axios.post('/api/panthera/customers/search', {
        type: this.customer.type,
        company: this.customer.company,
        lastname: this.customer.lastname,
        firstname: this.customer.firstname,
        email: this.customer.email,
        address: this.billingAddress.address,
        postcode: this.billingAddress.postcode,
        state: this.billingAddress.state,
        country: this.billingAddress.country,
        city: this.billingAddress.city,
        vat_id: this.customer.vat_id,
        tax_number: this.customer.tax_number,
        phone: this.billingAddress.phone,
      }).then(({ data }) => {
        this.pantheraCustomers = data.panthera_customers;
        this.isSearching = false;
      }).catch((err) => {
        if (err.request.status === 404) {
          this.toast.error(this.$t('customers.toast_panthera_customer_not_found'));
          this.isSearching = false;
          return;
        }
        this.toast.error(this.$t('customers.toast_error'));
      });
    },
    createPantheraCustomer() {
      this.disableCreate = true;
      this.isLoading = true;
      const customerSdiCode = this.setSdiCode();
      const customerPEC = this.customer.pec || '';
      axios.post('/api/panthera/customers/create', {
        type: this.customer.type,
        company: this.customer.company,
        lastname: this.customer.lastname,
        firstname: this.customer.firstname,
        email: this.customer.email,
        address: this.billingAddress.address,
        postcode: this.billingAddress.postcode,
        state: this.billingAddress.state,
        country: this.billingAddress.country,
        city: this.billingAddress.city,
        vat_id: this.customer.vat_id,
        tax_number: this.customer.tax_number,
        phone: this.billingAddress.phone,
        sdi_code: customerSdiCode,
        pec: customerPEC,
      }).then(({ data }) => {
        this.newPantheraCustomerId = data.panthera_customer_id;
        this.$emit('panthera_customer_has_been_created', this.newPantheraCustomerId);
        this.toast.success(this.$t('customers.toast_create_panthera_customer'));
      }).catch(() => {
        this.toast.error(this.$t('customers.toast_error'));
      });
    },
  },
};
</script>
